import { Routes } from '@angular/router';


export const content: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../../components/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'aplicaciones',
    loadChildren: () => import('../../components/aplicociones/aplicociones.module').then(m => m.AplicacionesModule)
  },
  {
    path: 'plataformas',
    loadChildren: () => import('../../components/plataformas/plataformas.module').then(m => m.PlataformasModule)
  }
];
